// extracted by mini-css-extract-plugin
export default {"signupPage":"SignupPage_signupPage__Atoq6","mainContent":"SignupPage_mainContent__Ip9Zu","footer":"SignupPage_footer__cURUP"};